<template lang="pug">
.historicalOrder
  .header-margin-bottom
  .member-center-header
    .arrow_icon(@click="$router.go(-1)")
      img(src="@/assets/images/arrow_left.svg", alt="alt")
    h1.date {{ $root.common.getNowTime('date',order.start_time) }}
  h1.title 訂單編號
  .order-num {{ order.number }}
  .info-list
    .info-item
      p 通路
      p 
        span(v-if="order.data.source_type == 1") 線上訂單
        span(v-if="order.data.source_type == 2") 線下訂單
    .info-item
      p 狀態
      p 
        span(v-if="order.status == 0") 建單中
        span(v-if="order.status == 1") 租借中
        span(v-if="order.status == 2") 已歸還
        span(v-if="order.status == 3") 已作廢
        span(v-if="order.status == 5") 未驗證的號碼
    .info-item
      p 電話
      p {{ order.phone_number }}
      .info-list(v-if="order.data.has_sedan")
    .vehicles-item
      p 車種
      p 燃油車
    .vehicles-item
      p 車輛數
      p {{ order.data.sedan.bike_quy }}
    .vehicles-item
      p 租借模式
      p 
        span(v-if="order.data.sedan.lease_type == 1") {{ order.data.sedan.lease_quy }}小時
        span(v-if="order.data.sedan.lease_type == 2") {{ order.data.sedan.lease_quy }}天
        span(v-if="order.data.sedan.lease_type == 3") 次數
    .vehicles-item(v-if="order.data.sedan.holiday_price")
      p 連續假期加價
      p NT$ {{ order.data.sedan.holiday_price }}
    .vehicles-item(v-if="order.data.sedan.return_price")
      p 異地歸還加價
      p NT$ {{ order.data.sedan.return_price }}
    .vehicles-item
      p 車輛優惠
      p 
  .info-list(v-if="order.data.has_motorcycle")
    .vehicles-item
      p 車種
      p 摩托車
    .vehicles-item
      p 車輛數
      p {{ order.data.motorcycle.bike_quy }}
    .vehicles-item
      p 租借模式
      p 
        span(v-if="order.data.motorcycle.lease_type == 1") {{ order.data.motorcycle.lease_quy }}小時
        span(v-if="order.data.motorcycle.lease_type == 2") {{ order.data.motorcycle.lease_quy }}天
        span(v-if="order.data.motorcycle.lease_type == 3") 次數
    .vehicles-item(v-if="order.data.motorcycle.holiday_price")
      p 連續假期加價
      p NT$ {{ order.data.motorcycle.holiday_price }}
    .vehicles-item(v-if="order.data.motorcycle.return_price")
      p 異地歸還加價
      p NT$ {{ order.data.motorcycle.return_price }}
    .vehicles-item
      p 車輛優惠
      p 
  .info-list(v-if="order.data.has_electric")
    .vehicles-item
      p 車種
      p 電動機車
    .vehicles-item
      p 車輛數
      p {{ order.data.electric.bike_quy }}
    .vehicles-item
      p 租借模式
      p 
        span(v-if="order.data.electric.lease_type == 1") {{ order.data.electric.lease_quy }}小時
        span(v-if="order.data.electric.lease_type == 2") {{ order.data.electric.lease_quy }}天
        span(v-if="order.data.electric.lease_type == 3") 次數
    .vehicles-item(v-if="order.data.electric.holiday_price")
      p 連續假期加價
      p NT$ {{ order.data.electric.holiday_price }}
    .vehicles-item(v-if="order.data.electric.return_price")
      p 異地歸還加價
      p NT$ {{ order.data.electric.return_price }}
    .vehicles-item
      p 車輛優惠
      p 
  .info-list(v-if="order.data.has_bicycle")
    .vehicles-item
      p 車種
      p 腳踏車
    .vehicles-item
      p 車輛數
      p {{ order.data.bicycle.bike_quy }}
    .vehicles-item
      p 租借模式
      p 
        span(v-if="order.data.bicycle.lease_type == 1") {{ order.data.bicycle.lease_quy }}小時
        span(v-if="order.data.bicycle.lease_type == 2") {{ order.data.bicycle.lease_quy }}天
        span(v-if="order.data.bicycle.lease_type == 3") 次數
    .vehicles-item(v-if="order.data.bicycle.holiday_price")
      p 連續假期加價
      p NT$ {{ order.data.bicycle.holiday_price }}
    .vehicles-item(v-if="order.data.bicycle.return_price")
      p 異地歸還加價
      p NT$ {{ order.data.bicycle.return_price }}
    .vehicles-item
      p 車輛優惠
      p 

  .info-list(v-if="order.data.discount_content")
    .detail_item
      .vehicles-item(v-if="order.data.discount_type == 1") 
        p 優惠小時
        p {{ order.data.discount_content }}小時
      .vehicles-item(v-if="order.data.discount_type == 2") 
        p 優惠折扣
        p 折扣 {{ order.data.discount_text }}
      .vehicles-item(v-if="order.data.discount_type == 3") 
        p 優惠現金
        p 現金 NT$ {{ order.data.discount_content }}
      span(v-if="order.data.discount_type == 4") 電子票券

  .total-list
    .total-item
      h2 訂單總金額
      .total-detail
        p 
          span(v-if="order.data.amount") {{ parseInt(order.data.amount) }}
          span(v-else) 0
</template>

<script>
export default {
  name: "order-detail",
  components: {},
  data () {
    return {
      order: false
    };
  },
  computed: {},
  created () {
    this.order = this.$route.params.order
  },
  mounted () { },
  methods: {
  }
};
</script>
<style lang="sass" scoped>
body
  position: relative
.historicalOrder
  background-color: #000
  padding: 0 4vmin 5vmin
  height: 100%
  overflow: auto
  h1.date
    font-size: 5vmin
    font-weight: 700
    text-align: center
    color: #fff
    padding-top: 6vmin
  .arrow_icon
    position: absolute
    top: 6vmin
    left: 6.1vmin
  .time
    font-size: 5vmin
    font-weight: 700
    text-align: center
    color: #fff
    padding: 4vmin
  h1.title
    font-size: 9vmin
    font-weight: 500
    text-align: center
    color: #fff
    margin-top: 10vmin
  .order-num
    font-size: 5vmin
    font-weight: 400
    text-align: center
    color: #22F48F
  .info-list
    margin-top: 10vmin
    .vehicles-title
      font-size: 5vmin
      font-weight: 400
      color: #898A8D
    .info-item,.vehicles-item
      display: flex
      justify-content: flex-start
      line-height: 10vmin
      p
        font-size: 5vmin
        font-weight: 400
        color: #fff
      p:nth-child(1)
        width: 45%
        color: #898A8D
  .total-list
    margin-top: 10vmin
    .total-item
      display: flex
      justify-content: flex-start
      line-height: 10vmin
      h2
        width: 45%
        font-size: 5vmin
        color: #898A8D
      .total-detail
        display: flex
        flex-direction: column
        p
          font-size: 5vmin
          font-weight: 400
          color: #fff
.header-margin-bottom
  margin-bottom: 75px
.member-center-header
  position: fixed
  left: 0px
  top: 0px
  width: 100%
  background: #000
  z-index: 10
  height: 75px
</style>
